import styled from "styled-components";

export const StyledTooltip = styled.span`
  display: inline-block;
  background-color: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
  color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
  border: 1px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
  padding: ${({noPadding}) => noPadding? 0 : '0.5rem'};
`;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Tags/shared.styles.js